import { render, staticRenderFns } from "./Buywh9.vue?vue&type=template&id=1a98eb93&scoped=true&"
import script from "./Buywh9.vue?vue&type=script&setup=true&lang=js&"
export * from "./Buywh9.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./Buywh9.vue?vue&type=style&index=0&id=1a98eb93&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a98eb93",
  null
  
)

export default component.exports